import { useQuery } from './use-query';
import type { DashboardStatistics } from '../types';

export const useDashboardStatistics = (filters: URLSearchParams) => {
  const { data, error, isLoading } = useQuery<DashboardStatistics>(`/stats?${filters}`);

  return {
    data,
    error,
    isLoading,
  };
};
